import {AngularDirective, NGX} from "../utility/ng";

export function getNavDirective(): AngularDirective {
    return NGX.makeTagDirective("common/nav", null, {controller: "="});
}
